module.exports = __webpack_public_path__ + "img/th_Boulder.b470deca.jpg";